<template>
	<div>
		<h5>VideoInspection</h5>
	</div>
</template>

<script>
	export default {
		name: "VideoInspection",
	};
</script>

<style scoped></style>
